import { useState } from 'react';

import { IAlphaMiniCartModel } from 'Types/Litium';
import { type RowSpecificVariantSelect } from 'Components/CustomerServiceCart';

const CartItemStock = ({
    variantSelectData,
    translations,
}: {
    variantSelectData: RowSpecificVariantSelect;
    translations: IAlphaMiniCartModel['translations'];
}) => {
    const [isStockListOpen, setIsStockListOpen] = useState(false);
    const stockDeliveryDateOnly = (dateTime: string) => dateTime.split('T')[0];

    return (
        <div className="mt-3.5 text-xs">
            <div className="flex justify-between">
                <div>
                    <div className="flex">
                        {`${translations.customerServiceCartInStock}: ${variantSelectData.quantity} ${translations.customerServiceCartUnit}`}
                    </div>
                    {isStockListOpen &&
                        variantSelectData.purchaseOrders.length > 0 && (
                            <div className="mt-1">
                                <div className="text-[11px]">
                                    {translations.customerServiceCartStockInfo}
                                </div>
                                {variantSelectData.purchaseOrders.map(
                                    (o, idx) => (
                                        <div
                                            key={o.deliveryDate}
                                            className={`flex ${
                                                idx > 0 && 'mt-1'
                                            }`}
                                        >
                                            {`${stockDeliveryDateOnly(
                                                o.deliveryDate
                                            )}: ${o.quantityInPurchaseOrder} ${
                                                translations.customerServiceCartUnit
                                            }`}
                                        </div>
                                    )
                                )}
                            </div>
                        )}
                    {isStockListOpen && variantSelectData.overbooked && (
                        <div
                            className={`mt-1 flex
                                ${
                                    variantSelectData.purchaseOrders.length >
                                        0 && 'border-t'
                                }
                            `}
                        >
                            {translations.customerServiceCartOverbooking}
                        </div>
                    )}
                </div>
                <div className="flex items-start">
                    <button
                        className="disabled:underline-none cursor-pointer select-none underline disabled:cursor-default disabled:opacity-30"
                        onClick={() => setIsStockListOpen(!isStockListOpen)}
                        disabled={
                            !variantSelectData.overbooked &&
                            variantSelectData.purchaseOrders.length < 1
                        }
                    >
                        {isStockListOpen
                            ? translations.customerServiceCartCloseStock
                            : translations.customerServiceCartShowStock}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CartItemStock;
